import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

import { loadSingle as loadableWrapper } from 'utils/loadable';

const paths = [
  {
    path: '/booking/dashboard',
    component: loadableWrapper({
      loader: () => import(/* webpackChunkName: "booking-dashboard.page" */'./pages/Booking/BookingDashboard')
    })
  },
  {
    path: '/booking/promo-code',
    component: loadableWrapper({
      loader: () => import(/* webpackChunkName: "booking-promo-code.page" */'./pages/Booking/BookingPromo')
    })
  },
  {
    path: '/booking/manual-booking',
    component: loadableWrapper({
      loader: () => import(/* webpackChunkName: "booking-manual-booking.page" */'./pages/Booking/ManualBookingDashboard')
    })
  },
  {
    path: '/booking/:id',
    component: loadableWrapper({
      loader: () => import(/* webpackChunkName: "booking.page" */'./pages/Booking')
    })
  },
  {
    path: '/trip/:id',
    component: loadableWrapper({
      loader: () => import(/* webpackChunkName: "trip.page" */'./pages/Trip')
    })
  },
  {
    path: '/user/:id',
    component: loadableWrapper({
      loader: () => import(/* webpackChunkName: "user.page" */'./pages/User')
    })
  },
  {
    path: '/dashboard',
    component: loadableWrapper({
      loader: () => import(/* webpackChunkName: "dashboard.page" */'./pages/Dashboard')
    })

  },
  {
    path: '/login',
    component: loadableWrapper({
      loader: () => import(/* webpackChunkName: "login.page" */'./pages/Auth/Login')
    })
  },
  {
    path: '/logout',
    component: loadableWrapper({
      loader: () => import(/* webpackChunkName: "logout.page" */'./pages/Auth/Logout')
    })
  },
  {
    path: '/search',
    component: loadableWrapper({
      loader: () => import(/* webpackChunkName: "search.page" */'./pages/Search')
    })
  },
  {
    path: '/customize',
    component: loadableWrapper({
      loader: () => import(/* webpackChunkName: "customize.page" */'./pages/Customize')
    })
  },
  {
    path: '/topic',
    component: loadableWrapper({
      loader: () => import(/* webpackChunkName: "topics.page" */'./pages/Section/Section/Sections')
    })
  },
  {
    path: '/topic/dashboard',
    component: loadableWrapper({
      loader: () => import(/* webpackChunkName: "topic-dashboard.page" */'./pages/Section/Analytic/TopicDashboard')
    })
  },
  {
    path: '/topic/dashboard/:id',
    component: loadableWrapper({
      loader: () => import(/* webpackChunkName: "topic-dashboard-analytic.page" */'./pages/Section/Analytic/TopicAnalytic')
    })
  },
  {
    path: '/topic/:id',
    component: loadableWrapper({
      loader: () => import(/* webpackChunkName: "topic.page" */'./pages/Section/Section/Section')
    })
  },
  {
    path: '/article',
    component: loadableWrapper({
      loader: () => import(/* webpackChunkName: "articles.page" */'./pages/Section/Article/Articles')
    })
  },
  {
    path: '/article/:id',
    component: loadableWrapper({
      loader: () => import(/* webpackChunkName: "article.page" */'./pages/Section/Article/Article')
    })
  },
  {
    path: '/city',
    component: loadableWrapper({
      loader: () => import(/* webpackChunkName: "cities.page" */'./pages/Section/City/Cities')
    })
  },
  {
    path: '/city/:city',
    component: loadableWrapper({
      loader: () => import(/* webpackChunkName: "city.page" */'./pages/Section/City/City')
    })
  },
  {
    path: '/log/:id',
    component: loadableWrapper({
      loader: () => import(/* webpackChunkName: "logs.page" */'./pages/Log/Lists')
    })
  },
  {
    path: '/log/detail/:id',
    component: loadableWrapper({
      loader: () => import(/* webpackChunkName: "log.page" */'./pages/Log/Detail')
    })
  },
  {
    path: '/redeem',
    component: loadableWrapper({
      loader: () => import(/* webpackChunkName: "redeem.page" */'./pages/Promo')
    })
  },
  {
    path: '/calendar',
    component: loadableWrapper({
      loader: () => import(/* webpackChunkName: "calendar.page" */'./pages/Calendar')
    })
  },
  {
    path: '/lx-availability',
    component: loadableWrapper({
      loader: () => import(/* webpackChunkName: "lx-availability.page" */'./pages/LxAvailability')
    })
  },
  {
    path: '/payment/manual',
    component: loadableWrapper({
      loader: () => import(/* webpackChunkName: "payment-manual.page" */'./pages/Payment/PaymentManual')
    })
  },
  {
    path: '/payment/export',
    component: loadableWrapper({
      loader: () => import(/* webpackChunkName: "payment-payout.page" */'./pages/Payment/PaymentPayout')
    })
  },
  {
    path: '/payment/statement',
    component: loadableWrapper({
      loader: () => import(/* webpackChunkName: "payment-statement.page" */'./pages/Payment/PaymentStatement')
    })
  },
  {
    path: '/payment/history',
    component: loadableWrapper({
      loader: () => import(/* webpackChunkName: "payment-history.page" */'./pages/Payment/PaymentHistory')
    })
  },
  {
    path: '/refund/pending',
    component: loadableWrapper({
      loader: () => import(/* webpackChunkName: "payment-refund.page" */'./pages/Payment/PaymentRefund')
    })
  },
  {
    path: '/trip-group',
    component: loadableWrapper({
      loader: () => import(/* webpackChunkName: "trip-group.page" */'./pages/TripGroup/TripGroups')
    })
  },
  {
    path: '/trip-group/:id',
    component: loadableWrapper({
      loader: () => import(/* webpackChunkName: "trip-group-detail.page" */'./pages/TripGroup/TripGroup')
    })
  },
  {
    path: '/redirect',
    component: loadableWrapper({
      loader: () => import(/* webpackChunkName: "redirect.page" */'./pages/Redirect')
    })
  },
  {
    path: '/swap-request',
    component: loadableWrapper({
      loader: () => import(/* webpackChunkName: "swap-request.page" */'./pages/SwapRequest')
    })
  },
  {
    path: '/swap-request/:id',
    component: loadableWrapper({
      loader: () => import(/* webpackChunkName: "swap-request-detail.page" */'./pages/SwapRequest/SwapRequestDetail')
    })
  },
  {
    path: '/config',
    component: loadableWrapper({
      loader: () => import(/* webpackChunkName: "config.page" */'./pages/SiteConfig/Config')
    })
  },
  {
    path: '/config-key',
    component: loadableWrapper({
      loader: () => import(/* webpackChunkName: "config-keys.page" */'./pages/SiteConfig/ConfigKeys')
    })
  },
  {
    path: '/translation',
    component: loadableWrapper({
      loader: () => import(/* webpackChunkName: "translation.page" */'./pages/SiteConfig/Translation')
    })
  },
  {
    path: '/testing',
    component: loadableWrapper({
      loader: () => import(/* webpackChunkName: "testings.page" */'./pages/SiteConfig/ABTesting')
    })
  },
  {
    path: '/testing/:id',
    component: loadableWrapper({
      loader: () => import(/* webpackChunkName: "testing.page" */'./pages/SiteConfig/ABTesting/Testing')
    })
  },
  {
    path: '/assignee',
    component: loadableWrapper({
      loader: () => import(/* webpackChunkName: "assignee.page" */'./pages/SiteConfig/Assignee')
    })
  },
  {
    path: '/meeting-point',
    component: loadableWrapper({
      loader: () => import(/* webpackChunkName: "meeting-point.page" */'./pages/SiteConfig/MeetingPoint')
    })
  },
  {
    path: '/affiliate/report',
    component: loadableWrapper({
      loader: () => import(/* webpackChunkName: "affiliate-report.page" */'./pages/Affiliate/Report')
    })
  },
  {
    path: '/affiliate/payment',
    component: loadableWrapper({
      loader: () => import(/* webpackChunkName: "affiliate-payment.page" */'./pages/Affiliate/Payment')
    })
  },
  {
    path: '/affiliate/users',
    component: loadableWrapper({
      loader: () => import(/* webpackChunkName: "affiliate-payment.page" */'./pages/Affiliate/Users')
    })
  },
  {
    path: '/affiliate/detail/:id',
    component: loadableWrapper({
      loader: () => import(/* webpackChunkName: "affiliate-payment.page" */'./pages/Affiliate/UserAffiliateDetail')
    })
  },
  {
    path: '/affiliate/transaction-detail/:id',
    component: loadableWrapper({
      loader: () => import(/* webpackChunkName: "affiliate-payment.page" */'./pages/Affiliate/TransactionDetail')
    })
  },
  {
    path: '/influencer/users',
    component: loadableWrapper({
      loader: () => import(/* webpackChunkName: "influencer.page" */'./pages/Influencer/Users')
    })
  },
  {
    path: '/influencer/users/:id',
    component: loadableWrapper({
      loader: () => import(/* webpackChunkName: "influencer.page" */'./pages/Influencer/InfluencerDetail')
    })
  },
  {
    path: '/review',
    component: loadableWrapper({
      loader: () => import(/* webpackChunkName: "review.page" */'./pages/Review')
    })
  },
  {
    path: '/review/:id',
    component: loadableWrapper({
      loader: () => import(/* webpackChunkName: "review-detail.page" */'./pages/Review/ReviewDetail')
    })
  },
  {
    path: '/search-n-replace',
    component: loadableWrapper({
      loader: () => import(/* webpackChunkName: "search-n-replace.page" */'./pages/SearchReplace')
    })
  },
  {
    path: '/highlight',
    component: loadableWrapper({
      loader: () => import(/* webpackChunkName: "highlight.page" */'./pages/Highlight')
    })
  },
  {
    path: '/restaurant',
    component: loadableWrapper({
      loader: () => import(/* webpackChunkName: "restaurants.page" */'./pages/Restaurant')
    })
  },
  {
    path: '/restaurant/:id',
    component: loadableWrapper({
      loader: () => import(/* webpackChunkName: "restaurant.page" */'./pages/Restaurant/Restaurant')
    })
  },
  {
    path: '/souvenir',
    component: loadableWrapper({
      loader: () => import(/* webpackChunkName: "souvenirs.page" */'./pages/Souvenir')
    })
  },
  {
    path: '/souvenir/:id',
    component: loadableWrapper({
      loader: () => import(/* webpackChunkName: "souvenir.page" */'./pages/Souvenir/Souvenir')
    })
  },
  {
    path: '/biennale/artist',
    component: loadableWrapper({
      loader: () => import(/* webpackChunkName: "biennale-artists.page" */'./pages/Biennale/Artist')
    })
  },
  {
    path: '/biennale/artist/:id',
    component: loadableWrapper({
      loader: () => import(/* webpackChunkName: "biennale-artist.page" */'./pages/Biennale/Artist/Artist')
    })
  },
  {
    path: '/biennale/art',
    component: loadableWrapper({
      loader: () => import(/* webpackChunkName: "biennale-arts.page" */'./pages/Biennale/Art')
    })
  },
  {
    path: '/biennale/art/:id',
    component: loadableWrapper({
      loader: () => import(/* webpackChunkName: "biennale-art.page" */'./pages/Biennale/Art/Art')
    })
  },
  {
    path: '/biennale/art-plan',
    component: loadableWrapper({
      loader: () => import(/* webpackChunkName: "biennale-art-plans.page" */'./pages/Biennale/ArtPlan')
    })
  },
  {
    path: '/biennale/art-plan/:id',
    component: loadableWrapper({
      loader: () => import(/* webpackChunkName: "biennale-art-plan.page" */'./pages/Biennale/ArtPlan/ArtPlan')
    })
  },
  {
    path: '/biennale/art-community',
    component: loadableWrapper({
      loader: () => import(/* webpackChunkName: "biennale-art-communities.page" */'./pages/Biennale/ArtCommunity')
    })
  },
  {
    path: '/biennale/art-community/:id',
    component: loadableWrapper({
      loader: () => import(/* webpackChunkName: "biennale-art-community.page" */'./pages/Biennale/ArtCommunity/ArtCommunity')
    })
  },
  {
    path: '/approved-trips',
    component: loadableWrapper({
      loader: () => import(/* webpackChunkName: "approved-trips.page" */'./pages/ApprovedTrips')
    })
  },
  {
    path: '/pricing',
    component: loadableWrapper({
      loader: () => import(/* webpackChunkName: "pricing.page" */'./pages/Pricing')
    })
  },
  {
    path: '/send-sms',
    component: loadableWrapper({
      loader: () => import(/* webpackChunkName: "approved-trips.page" */'./pages/SMS/SendSMS')
    })
  },
  {
    path: '/partner/availability',
    component: loadableWrapper({
      loader: () => import(/* webpackChunkName: "partner-availability.page" */'./pages/Partner/Availability')
    })
  },
  {
    path: '/fruit-market/recommandation',
    component: loadableWrapper({
      loader: () => import(/* webpackChunkName: "recommandation.page" */'./pages/FruitMarket/Recommandation')
    })
  },
  {
    path: '/fruit-market/seller',
    component: loadableWrapper({
      loader: () => import(/* webpackChunkName: "fruit-market.sellers.page" */'./pages/FruitMarket/Seller')
    })
  },
  {
    path: '/fruit-market/order',
    component: loadableWrapper({
      loader: () => import(/* webpackChunkName: "fruit-market.orders.page" */'./pages/FruitMarket/Order')
    })
  },
  {
    path: '/fruit-market/order/:id',
    component: loadableWrapper({
      loader: () => import(/* webpackChunkName: "fruit-market.order.page" */'./pages/FruitMarket/Order/Order')
    })
  },
  {
    path: '/local-community',
    component: loadableWrapper({
      loader: () => import(/* webpackChunkName: "local-communities.page" */'./pages/LocalCommunity')
    })
  },
  {
    path: '/local-community/:id',
    component: loadableWrapper({
      loader: () => import(/* webpackChunkName: "local-community.page" */'./pages/LocalCommunity/LocalCommunity')
    })
  },
  {
    path: '/walking-tour/products/:id',
    component: loadableWrapper({
      loader: () => import(/* webpackChunkName: "walking-tour-product-detail.page" */'./pages/WalkingTour/ProductDetail')
    })
  },
  {
    path: '/walking-tour/products',
    component: loadableWrapper({
      loader: () => import(/* webpackChunkName: "walking-tour-products.page" */'./pages/WalkingTour/Products')
    })
  },
  {
    path: '/walking-tour/bookings/:id',
    component: loadableWrapper({
      loader: () => import(/* webpackChunkName: "walking-tour-booking-detail.page" */'./pages/WalkingTour/BookingDetail')
    })
  },
  {
    path: '/walking-tour/bookings',
    component: loadableWrapper({
      loader: () => import(/* webpackChunkName: "walking-tour-bookings.page" */'./pages/WalkingTour/Bookings')
    })
  },
  {
    path: '/walking-tour/manage-availability',
    component: loadableWrapper({
      loader: () => import(/* webpackChunkName: "walking-tour-manageAvailability.page */'./pages/WalkingTour/ManageAvailability')
    })
  },
  {
    path: '/cx-handoff',
    component: loadableWrapper({
      loader: () => import(/* webpackChunkName: "cx-handoff.page" */'./pages/CxHandoff/Handoffs')
    })
  }

];

const Routes = () => {
  return (
    <Switch>
      {paths.map(path => (
        <Route key={path.path} path={path.path} exact component={path.component} />
      ))}
      <Redirect to="/dashboard" />
    </Switch>
  );
};

export default Routes;



// WEBPACK FOOTER //
// ./src/Routes.js